import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { App } from './App.jsx';
import { SessionProvider } from './contexts/SessionContext.jsx';
import { DialogHost } from './dialogs/DialogHost.jsx';
import './i18n/config.js';
import './index.css';

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <BrowserRouter>
      <SessionProvider>
        <App />
        <DialogHost />
      </SessionProvider>
    </BrowserRouter>
  </StrictMode>,
);
